import React from 'react'
import clsx from 'clsx'

import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconProvider } from 'assets/icons/provider.svg'
import { ReactComponent as IconProduct } from 'assets/icons/product.svg'
import { ReactComponent as IconService } from 'assets/icons/service.svg'
import { ReactComponent as IconUser } from 'assets/icons/user.svg'
import { ReactComponent as IconTelefone } from 'assets/icons/telefone.svg'
import { ReactComponent as IconEmail } from 'assets/icons/email.svg'
import { ReactComponent as IconWeb } from 'assets/icons/web.svg'
import { ReactComponent as IconLocation } from 'assets/icons/location.svg'
import { ReactComponent as IconAgenda } from 'assets/icons/agenda.svg'
import { ReactComponent as IconCoins } from 'assets/icons/coins.svg'
import { ReactComponent as IconBarChart } from 'assets/icons/bar-chart.svg'
import { ReactComponent as IconType } from 'assets/icons/outstanding.svg'

import { useHistory } from 'react-router-dom'
import useStyles from './styles'

const icons = {
  provider: IconProvider,
  product: IconProduct,
  service: IconService,
  user: IconUser,
  telefone: IconTelefone,
  email: IconEmail,
  web: IconWeb,
  location: IconLocation,
  agenda: IconAgenda,
  coins: IconCoins,
  barChart: IconBarChart,
  type: IconType,
}

const SimpleList = props => {
  const { elements, isLink, isVendors, height } = props
  const classes = useStyles()
  const history = useHistory()

  return (
    <Paper
      style={{ maxHeight: height }}
      className={clsx(height ? classes.wrap : null)}
    >
      <List role="list" disablePadding>
        {elements.map((element, index) => {
          return (
            <ListItem
              key={element.id || `element-${index}`}
              className={classes.root}
              button={isLink}
              divider
              component="li"
              role="listitem"
              onClick={() =>
                isLink &&
                history.push({
                  pathname: `/app/vendors/${element.id}`,
                  state: { from: 'home' },
                })
              }
            >
              <ListItemIcon className={classes.icon}>
                {isVendors ? (
                  <SvgIcon component={IconProvider} />
                ) : (
                  <SvgIcon component={icons[element.icon]} />
                )}
              </ListItemIcon>
              <ListItemText
                className={classes.textWrapper}
                disableTypography
                primary={
                  <Typography className={classes.primary} variant="body2">
                    {element.name}
                  </Typography>
                }
                secondary={
                  element.secondary ? (
                    <Typography
                      className={classes.secondary}
                      variant="subtitle1"
                    >
                      {element.secondary}
                    </Typography>
                  ) : null
                }
              />
            </ListItem>
          )
        })}
      </List>
    </Paper>
  )
}

SimpleList.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.object),
  isLink: PropTypes.bool,
  isVendors: PropTypes.bool,
  height: PropTypes.number,
}

export default SimpleList
